import React from 'react';
import { Button } from './ui/Button';
import { Shield, Target, ChevronRight } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen w-full overflow-hidden flex items-center pt-20" data-id="element-92">
      {/* Background Grid */}
      <div className="absolute inset-0 bg-grid-pattern opacity-20 pointer-events-none" data-id="element-93" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0a1628]/0 via-[#0a1628]/50 to-[#0a1628] pointer-events-none" data-id="element-94" />

      <div className="container mx-auto px-4 relative z-10 grid lg:grid-cols-2 gap-12 items-center" data-id="element-95">
        {/* Text Content */}
        <div className="space-y-8" data-id="element-96">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#00d4ff]/10 border border-[#00d4ff]/30 text-[#00d4ff] text-xs font-mono tracking-wider uppercase" data-id="element-97">
            <span className="relative flex h-2 w-2" data-id="element-98">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#00d4ff] opacity-75" data-id="element-99"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-[#00d4ff]" data-id="element-100"></span>
            </span>
            System Online // v2.4.0
          </div>

          <h1 className="text-5xl md:text-6xl lg:text-7xl font-extrabold leading-tight text-white" data-id="element-101">
            COMPETITIVE <br data-id="element-102" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#00d4ff] to-blue-600 text-glow" data-id="element-103">
              INTELLIGENCE
            </span>{' '}
            <br data-id="element-104" />
            COMMAND CENTER
          </h1>

          <p className="text-lg text-slate-400 max-w-xl border-l-2 border-[#00d4ff]/30 pl-6" data-id="element-105">
            Dominate your market with military-grade surveillance of your
            competition. Real-time threat detection, strategic forecasting, and
            tactical insights.
          </p>

          <div className="flex flex-wrap gap-4" data-id="element-106">
            <Button size="lg" icon={Target} data-id="element-107">
              Initialize Scan
            </Button>
            <Button variant="secondary" size="lg" icon={Shield} data-id="element-108">
              View Demo
            </Button>
          </div>

          <div className="flex items-center gap-8 pt-8 border-t border-slate-800" data-id="element-109">
            <div data-id="element-110">
              <div className="text-3xl font-mono font-bold text-white" data-id="element-111">
                24/7
              </div>
              <div className="text-xs text-slate-500 uppercase tracking-wider" data-id="element-112">
                Surveillance
              </div>
            </div>
            <div data-id="element-113">
              <div className="text-3xl font-mono font-bold text-[#00d4ff]" data-id="element-114">
                98%
              </div>
              <div className="text-xs text-slate-500 uppercase tracking-wider" data-id="element-115">
                Accuracy
              </div>
            </div>
            <div data-id="element-116">
              <div className="text-3xl font-mono font-bold text-white" data-id="element-117">
                150+
              </div>
              <div className="text-xs text-slate-500 uppercase tracking-wider" data-id="element-118">
                Data Sources
              </div>
            </div>
          </div>
        </div>

        {/* Radar Visual */}
        <div className="relative flex justify-center items-center h-[500px]" data-id="element-119">
          {/* Radar Container */}
          <div className="relative w-[400px] h-[400px] md:w-[500px] md:h-[500px] rounded-full border border-[#00d4ff]/20 bg-[#0a1628]/50 backdrop-blur-sm" data-id="element-120">
            {/* Grid Rings */}
            <div className="absolute inset-0 rounded-full border border-[#00d4ff]/10 scale-75" data-id="element-121"></div>
            <div className="absolute inset-0 rounded-full border border-[#00d4ff]/10 scale-50" data-id="element-122"></div>
            <div className="absolute inset-0 rounded-full border border-[#00d4ff]/10 scale-25" data-id="element-123"></div>

            {/* Crosshairs */}
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-124">
              <div className="w-full h-[1px] bg-[#00d4ff]/20" data-id="element-125"></div>
            </div>
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-126">
              <div className="h-full w-[1px] bg-[#00d4ff]/20" data-id="element-127"></div>
            </div>

            {/* Radar Sweep */}
            <div className="absolute inset-0 rounded-full overflow-hidden" data-id="element-128">
              <div className="absolute inset-0 radar-sweep origin-center rounded-full" data-id="element-129"></div>
            </div>

            {/* Blips/Dots */}
            <div className="absolute top-1/4 left-1/4 w-3 h-3 bg-red-500 rounded-full shadow-[0_0_10px_rgba(239,68,68,0.8)] animate-pulse-dot" data-id="element-130"></div>
            <div className="absolute bottom-1/3 right-1/4 w-2 h-2 bg-yellow-500 rounded-full shadow-[0_0_10px_rgba(234,179,8,0.8)] animate-pulse-dot" style={{
            animationDelay: '1s'
          }} data-id="element-131"></div>
            <div className="absolute top-1/2 right-1/6 w-2 h-2 bg-green-500 rounded-full shadow-[0_0_10px_rgba(34,197,94,0.8)] animate-pulse-dot" style={{
            animationDelay: '2s'
          }} data-id="element-132"></div>

            {/* Center HUD */}
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-133">
              <div className="w-20 h-20 bg-[#0a1628] border border-[#00d4ff] rounded-full flex items-center justify-center z-10 shadow-[0_0_20px_rgba(0,212,255,0.2)]" data-id="element-134">
                <Target className="text-[#00d4ff] w-8 h-8 animate-pulse" data-id="element-135" />
              </div>
            </div>
          </div>

          {/* Floating Data Cards */}
          <div className="absolute top-10 right-0 bg-[#0a1628]/90 border border-[#00d4ff]/30 p-3 rounded backdrop-blur-md text-xs font-mono" data-id="element-136">
            <div className="text-[#00d4ff] mb-1" data-id="element-137">TARGET ACQUIRED</div>
            <div className="text-white" data-id="element-138">Competitor A: +12% Growth</div>
          </div>
          <div className="absolute bottom-20 left-0 bg-[#0a1628]/90 border border-red-500/30 p-3 rounded backdrop-blur-md text-xs font-mono" data-id="element-139">
            <div className="text-red-500 mb-1" data-id="element-140">THREAT DETECTED</div>
            <div className="text-white" data-id="element-141">New Pricing Model Found</div>
          </div>
        </div>
      </div>
    </section>;
}